import { render, staticRenderFns } from "./WasteConfirmWaste.vue?vue&type=template&id=b420b41e&"
import script from "./WasteConfirmWaste.vue?vue&type=script&lang=js&"
export * from "./WasteConfirmWaste.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports